import { gatewayApi as api } from './gatewayApi';
import { PartAttribute } from './partAttributesApi';

export interface PartSecAttribute {
  Id?: number;
  PartAttributeId: number;
  PartAttribute?: Pick<PartAttribute, 'Id' | 'Name'>;
  Name: string;
  Description?: string;
  Active: boolean;
  CreatedDate?: string;
  ModifiedDate?: string;
}

export interface PartSecAttributeListResponse {
  data: PartSecAttribute[];
  total: number;
}

export interface PartSecAttributeSearchParams {
  page?: number;
  pageSize?: number;
  search?: string;
  active?: boolean;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export const partSecAttributesApi = {
  getAll: (params?: PartSecAttributeSearchParams): Promise<PartSecAttributeListResponse> =>
    api.get('/partsecattributes', params),

  getById: (id: number): Promise<PartSecAttribute> =>
    api.get(`/partsecattributes/${id}`),

  create: (item: Omit<PartSecAttribute, 'Id'>): Promise<PartSecAttribute> =>
    api.post('/partsecattributes', item),

  update: (id: number, item: Partial<PartSecAttribute>): Promise<PartSecAttribute> =>
    api.put(`/partsecattributes/${id}`, item),

  delete: (id: number): Promise<{ success: boolean; message: string }> =>
    api.delete(`/partsecattributes/${id}`),

  search: (params: PartSecAttributeSearchParams): Promise<PartSecAttributeListResponse> =>
    api.post('/partsecattributes/search', params),

  bulkActivate: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.put('/partsecattributes/bulk-activate', { ids }),

  bulkDeactivate: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.put('/partsecattributes/bulk-deactivate', { ids }),

  bulkDelete: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.post('/partsecattributes/bulk-delete', { ids }),

  getStatistics: (): Promise<{ total: number; active: number; inactive: number }> =>
    api.get('/partsecattributes/statistics'),

  exportToCSV: (params?: PartSecAttributeSearchParams): Promise<Blob> =>
    api.getBlob('/partsecattributes/export', { params }),

  validation: {
    validate: (item: Partial<PartSecAttribute>): string[] => {
      const errors: string[] = [];
      if (!item.PartAttributeId && (item.PartAttributeId as any) !== 0) errors.push('Part Attribute is required');
      if (!item.Name || item.Name.trim().length === 0) errors.push('Name is required');
      else if (item.Name.trim().length < 2) errors.push('Name must be at least 2 characters');
      else if (item.Name.trim().length > 100) errors.push('Name must be less than 100 characters');
      if (item.Description && item.Description.length > 500) errors.push('Description must be less than 500 characters');
      if (item.Active === undefined || item.Active === null) errors.push('Active status is required');
      return errors;
    },
    validateBulk: (ids: number[]): string[] => {
      const errors: string[] = [];
      if (!ids || ids.length === 0) errors.push('Select at least one item');
      if (ids.length > 100) errors.push('Too many selected items');
      return errors;
    },
  },
};

export default partSecAttributesApi; 